'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _ramda = require('ramda');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxConnect = require('redux-connect');
var _reactRouter = require('react-router');
var _reduxForm = require('redux-form');
var _components = require('../../components');
var _routerAdapter = require('../../helpers/routerAdapter');
var _company = require('../../redux/modules/company');















var _consultation = require('../../redux/modules/consultation');
var _shareModal = require('../../redux/modules/shareModal');
var _messageModal = require('../../redux/modules/messageModal');
var _propertyDetails = require('../../redux/modules/propertyDetails');





var _reviewedPins = require('../../redux/modules/reviewedPins');
var _favoriteProperties = require('../../redux/modules/favoriteProperties');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var


CompanyPage = function (_Component) {_inherits(CompanyPage, _Component);function CompanyPage() {var _temp, _this, _ret;_classCallCheck(this, CompanyPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      showMessageModal: false }, _this.

































    parseIdFromRoute = function () {var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var idPart = route.split('/').pop();
      return idPart.includes('pid') ? idPart.split('pid_').pop() : '';
    }, _this.

    checkPopupIsOpen = function (routeData) {
      if (routeData && (routeData.pid || routeData.route.includes('pid'))) {
        var id = routeData.pid || _this.parseIdFromRoute(routeData.route);
        setTimeout(function () {return _this.openDetailsPopup(id);}, 1000);
      }
    }, _this.

    openDetailsPopup = function (propertyId) {return _this.props.openDetailsPopup({ propertyId: propertyId });}, _temp), _possibleConstructorReturn(_this, _ret);}CompanyPage.prototype.componentWillMount = function componentWillMount() {if (this.props.error && this.props.error.status === 404) {this.context.router.replace((0, _appendLocale2.default)(this.props.locale, '/professionals'));}};CompanyPage.prototype.componentDidMount = function componentDidMount() {var _this2 = this;this.checkPopupIsOpen(this.props.routeData);this.unlistenRouteChange = _reactRouter.browserHistory.listen(function (_ref) {var action = _ref.action,pathname = _ref.pathname;if (action === 'POP') {var propertyId = _this2.parseIdFromRoute(pathname);if (!!propertyId) {_this2.openDetailsPopup(propertyId);}}});};CompanyPage.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {if (nextProps.error && nextProps.error.status === 404 && !this.props.error) {this.context.router.replace((0, _appendLocale2.default)(this.props.locale, '/professionals'));}};CompanyPage.prototype.componentWillUnmount = function componentWillUnmount() {this.props.reset();this.props.consultationReset();this.unlistenRouteChange();};CompanyPage.prototype.

  render = function render() {var _props =













    this.props,isNative = _props.isNative,_props$companyDetails = _props.companyDetails,translatedDescriptionRequired = _props$companyDetails.translatedDescriptionRequired,descriptionLoaded = _props$companyDetails.descriptionLoaded,translatedDescriptionText = _props$companyDetails.translatedDescriptionText,showOriginalDescription = _props$companyDetails.showOriginalDescription,descriptionLoading = _props$companyDetails.descriptionLoading,translatedAdditionalInfoRequired = _props$companyDetails.translatedAdditionalInfoRequired,additionalInfoLoaded = _props$companyDetails.additionalInfoLoaded,translatedAdditionalInfoText = _props$companyDetails.translatedAdditionalInfoText,showOriginalAdditionalInfo = _props$companyDetails.showOriginalAdditionalInfo,additionalInfoLoading = _props$companyDetails.additionalInfoLoading;

    var descriptionData = {
      translatedRequired: translatedDescriptionRequired,
      loaded: descriptionLoaded,
      translatedText: translatedDescriptionText,
      showOriginal: showOriginalDescription,
      loading: descriptionLoading };

    var additionalInfoData = {
      translatedRequired: translatedAdditionalInfoRequired,
      loaded: additionalInfoLoaded,
      translatedText: translatedAdditionalInfoText,
      showOriginal: showOriginalAdditionalInfo,
      loading: additionalInfoLoading };


    return (
      _react2.default.createElement(_components.Company, _extends({},
      this.props, {
        isNative: isNative,
        descriptionData: descriptionData,
        additionalInfoData: additionalInfoData,
        showMessageModal: this.state.showMessageModal,
        routeData: this.props.routeData,
        setPinAsReviewed: this.props.setPinAsReviewed,
        reviewedPins: this.props.reviewedPins,
        favoriteProperties: this.props.favoriteProperties.favoriteIDs,
        toggleFavorite: this.props.toggleFavorite,
        userToken: this.props.userToken })));


  };return CompanyPage;}(_react.Component);


CompanyPage.propTypes = {
  locale: _propTypes2.default.string,
  companyId: _propTypes2.default.string.isRequired,
  error: _propTypes2.default.object,
  company: _propTypes2.default.object,
  reset: _propTypes2.default.func,
  resetReduxForm: _propTypes2.default.func,
  consultationReset: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  routeData: _propTypes2.default.object,
  openDetailsPopup: _propTypes2.default.func,
  openModalShare: _propTypes2.default.func.isRequired,
  hideModalShare: _propTypes2.default.func.isRequired,
  isModalShareOpen: _propTypes2.default.bool.isRequired,
  setPinAsReviewed: _propTypes2.default.func.isRequired,
  reviewedPins: _propTypes2.default.array,
  favoriteProperties: _propTypes2.default.object,
  toggleFavorite: _propTypes2.default.func,
  userToken: _propTypes2.default.string,
  loadFavorites: _propTypes2.default.func,
  openLightbox: _propTypes2.default.func,
  hideLightbox: _propTypes2.default.func,
  changeLightboxActiveSlide: _propTypes2.default.func,
  currentImage: _propTypes2.default.number,
  isLightboxOpen: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool,
  companyDetails: _propTypes2.default.object,
  location: _propTypes2.default.object.isRequired };


CompanyPage.contextTypes = {
  router: _propTypes2.default.object.isRequired };


var asyncData = [{
  key: 'fetchCompanyData',
  promise: function promise(_ref2) {var companyId = _ref2.params.companyId,_ref2$store = _ref2.store,dispatch = _ref2$store.dispatch,getState = _ref2$store.getState;var _getState =
    getState(),company = _getState.company,userAuthentication = _getState.userAuthentication;
    var currentCompanyId = (0, _get2.default)(company, 'data.id');
    var loading = (0, _get2.default)(company, 'loading');
    var token = (0, _get2.default)(userAuthentication, 'accessToken') || (0, _get2.default)(userAuthentication, 'data.access_token');
    var companyOwnId = (0, _get2.default)(userAuthentication, 'data.agent_data.agency_id');
    var shouldLoad = companyId && companyId !== 'null' && companyId !== currentCompanyId && !loading;
    if (token && companyOwnId === companyId) {
      return shouldLoad && dispatch((0, _company.loadOwnCompany)({ companyId: companyId, token: token }));
    }

    return shouldLoad && dispatch((0, _company.loadCompany)(companyId));
  } },

{
  key: 'fetchCompanyProps',
  promise: function promise(_ref3) {var companyId = _ref3.params.companyId,_ref3$store = _ref3.store,dispatch = _ref3$store.dispatch,getState = _ref3$store.getState;var _getState2 =
    getState(),company = _getState2.company;
    var currentCompanyId = (0, _get2.default)(company, 'data.id');
    var properties = (0, _get2.default)(company, 'properties');
    var loading = (0, _get2.default)(company, 'propertiesLoading');
    var shouldLoad = !loading && companyId && companyId !== 'null' && (!properties || !properties.length || companyId !== currentCompanyId);

    return shouldLoad && dispatch((0, _company.loadCompanyProps)(companyId));
  } }];


var mapStateToProps = function mapStateToProps(store, _ref4) {var routeParams = _ref4.routeParams;
  var routeData = (0, _routerAdapter.extractRouteData)(store.routing, store.lang.locale);

  return {
    locale: routeData.locale,
    isMobile: store.windowDimentions.isMobile,
    isNative: store.native.isNative,
    translate: (0, _reduxPagan.getLang)(store.lang, 'static'),
    companyId: routeParams.companyId,
    company: store.company.data || {},
    consultation: store.consultation.data,
    formConsultationError: store.consultation.formError,
    companyDetails: store.company || {},
    formConsultationSubmitted: store.consultation.formSubmitted,
    formConsultationSubmitting: store.consultation.formSubmitting,
    error: store.company.error,
    isLightboxOpen: store.propertyDetails.isLightboxOpen,
    currentImage: store.propertyDetails.currentImage,
    properties: store.company.properties,
    mobileCompanyContactIsOpen: store.company.mobileCompanyContactIsOpen,
    userId: store.userAuthentication.userIsAuthorized && store.userAuthentication.data.id,
    userToken: store.userAuthentication.data ? store.userAuthentication.data.access_token : null,
    formSubmitted: store.company.formSubmitted,
    formSubmitting: store.company.formSubmitting,
    formError: store.company.formError,
    isDetailsModalOpen: store.propertyDetails.isDetailsModalOpen,
    isModalShareOpen: store.shareModal.isModalShareOpen,
    reviewedPins: store.reviewedPins.reviewedIds,
    favoriteProperties: store.favoriteProperties };

};

var mapDispatchToProps = {
  loadCompany: _company.loadCompany,
  loadOwnCompany: _company.loadOwnCompany,
  loadCompanyProps: _company.loadCompanyProps,
  openCompanyContactModal: _company.openCompanyContactModal,
  closeCompanyContactModal: _company.closeCompanyContactModal,
  openDetailsPopup: _propertyDetails.openDetailsPopup,
  sendCompanyContactUsForm: _company.sendCompanyContactUsForm,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  reset: _company.reset,
  resetReduxForm: _reduxForm.reset,
  consultationReset: _consultation.consultationReset,
  sendConsultationForm: _consultation.sendConsultationForm,
  openModalShare: _shareModal.openModalShare,
  hideModalShare: _shareModal.hideModalShare,
  setPinAsReviewed: _reviewedPins.setPinAsReviewed,
  toggleFavorite: _favoriteProperties.toggleFavorite,
  loadFavorites: _favoriteProperties.loadFavorites,
  openLightbox: _propertyDetails.openLightbox,
  hideLightbox: _propertyDetails.hideLightbox,
  changeLightboxActiveSlide: _propertyDetails.changeLightboxActiveSlide,
  translateDescription: _company.translateDescription,
  translateAdditionalInfo: _company.translateAdditionalInfo,
  detectDescriptionLanguage: _company.detectDescriptionLanguage,
  detectAdditionalInfoLanguage: _company.detectAdditionalInfoLanguage,
  toggleDescriptionTranslation: _company.toggleDescriptionTranslation,
  toggleAdditionalInfoTranslation: _company.toggleAdditionalInfoTranslation,
  resetTranslate: _company.resetTranslate };exports.default =


(0, _ramda.compose)(
(0, _reduxConnect.asyncConnect)(asyncData),
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(
CompanyPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/CompanyPage/CompanyPage.js
// module id = 3054
// module chunks = 0